import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'root',
  'container',
  'slide',
  'navigation',
  'pagination',
  'scrollbar'
]);

/**
 * @typedef {import('@chakra-ui/styled-system').SystemStyleObject} SystemStyleObject
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("container" | "slide" | "navigation" | "pagination" | "scrollbar")[]
 * }>} MediaCarouselStyles
 */
export const mediaCarouselStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.MediaCarousel} args.component - MediaCarousel component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {MediaCarouselStyles} - Component styles
   */
  baseStyle: ({component}) => {
    return {
      root: {
        backgroundImage: '',
      },
    };
  },
  variants: {
    /**
     * @param {Object} args - Component arguments
     * @param {Contentful.MediaCarousel} args.component - MediaCarousel component data
     * @param {boolean} [args.isComplete] - Whether component has all fields
     * @param {boolean} [args.isFetching] - Whether additional data is being fetched
     *
     * @returns {MediaCarouselStyles} - Component styles
     */
    'CF-010': (args) => ({
      paginationContainer: {
        alignItems: 'center',
        backdropFilter: 'blur(1px)',
        background: 'brandColors.greyscale40',
        borderRadius: {base: '2px', md: '5px'},
        bottom: {base: '10px', md: '32px'},
        display: 'flex',
        gap: {base: '2px', md: '10px'},
        padding: {base: '3px 4px', md: '8px 7px'},
        position: 'absolute',
        right: {base: '16px', md: '50%'},
        transform: {base: 'none', md: 'translateX(50%)'},
        zIndex: 1,
      },

      navigation: {
        backdropFilter: 'none',
        backgroundColor: 'transparent',
        display: 'flex',
        height: '24px',
        position: 'static',
        transform: 'none',
        width: '24px',

        _after: {
          backgroundSize: '10px 10px',
        },

        _hover: {
          backgroundColor: 'transparent',
        },
      },

      pagination: {
        color: 'white',
        display: 'flex',
        flexBasis: 0,
        fontSize: {base: '10px', md: '12.472px'},
        fontWeight: '500',
        gap: {base: '3px', md: '3.742px'},
        lineHeight: '24px',
        position: 'static',
        transform: 'none',
      },

      autoplay: {
        bottom: {base: '10px', md: '32px'},
        left: {base: '16px', md: '32px'},
        padding: {base: '5px', md: '5.5px'},
        paddingX: {base: '5px', md: '5.5px'},
        position: 'absolute',
        zIndex: 1,
      },
    }),

    'CF-011': (args) => ({}),
  },
});
